import React from "react";
import { useDispatch } from "react-redux";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingMenusPaginated, menuCleanSearchText, menuSetSearchText, startSearchingMenusPaginated } from "../../app/actions/menuActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackMenu = ({ searchText, setSearchText, itemsPerPage }) => {
    debugLogPages(":: SearchBackMenu");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchMenus", event: "SearchMenus-Clicked", search: event.target.value });

      dispatch(menuSetSearchText(event.target.value));

      dispatch(startSearchingMenusPaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingMenusPaginated());

      dispatch(menuCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackMenu;
